import React, { useState, useRef } from 'react';
import { FilterControl } from './facetControl.jsx';

import '../../css/search.scoped.scss';

const CheckboxGroup = ({ applyFilters, clearFilter, filters, idx }) => {
  const onChangeImage = (event) => {
    if (filters?.images) {
      clearFilter('images')
      return
    }

    applyFilters({ images: true }, [])
  }

  const onChangeCollection = (event) => {
    if (filters?.gokm_owned) {
      clearFilter('gokm_collection')
      return
    }

    applyFilters({ gokm_collection: true }, [])
  }

  return <div className="card" key={idx}>
    <div className="card-body">
      <div className="vertical-container m-3">
          <label id="filter-images-label" className="checkbox single-checkbox">
          <input className="custom-checkbox"
                 type="checkbox"
                 defaultChecked={filters?.images === true}
                 id="filter-images"
                 aria-labelledby="filter-images-label"
                 onClick={onChangeImage}/> Has image
          </label>
          {/* filter-has-image is-size-7 Removing these classes as it is making the font to be very small*/}
          <label id="" className="checkbox single-checkbox ">
            <input className="custom-checkbox"
                   type="checkbox"
                   defaultChecked={filters?.gokm_collection === true}
                   id="filter-collection"
                   aria-labelledby=""
                   onClick={onChangeCollection} /> GOKM collection
          </label>
      </div>
    </div>
  </div>  
}

const AccordionPane = ({ accordionId,
                         aggregations,
                         applyFilters,
                         count,
                         clearFilter,
                         collapseAllFunc,
                         filters,
                         height,
                         openPane,
                         paneConfig,
                         setOpenPane
                        }) => {
  return <div className="card" key={`key-filters-accordion-card-${paneConfig.name}`}>
          <div
            className="mfp-collapse-hdg"
            id={`heading-${paneConfig.name}`}
          >
            <h2 className="mb-0 pb-2">
              <button
                className={`btn btn-link mfp-heading-text ${openPane === paneConfig.name ? "" : "collapsed"}`}
                type="button"
                data-target={`#collapse-${paneConfig.name}`}
                aria-expanded="false"
                aria-controls={`collapse-${paneConfig.name}`}
                onClick={() => setOpenPane(prevOpen => (prevOpen === paneConfig.name ? null : paneConfig.name))}
              >
                <i className="icon icon-accordion-carets icon--slate-gray pr-1 mr-1"></i>{" "}
                {paneConfig.label}
              </button>
            </h2>
          </div>
          <div
            id={`collapse-${paneConfig.name}`}
            className={`collapse ${openPane === paneConfig.name ? "is-active" : ""}`}
            aria-labelledby={`heading-${paneConfig.name}`}
            data-parent={accordionId}
            style={openPane === paneConfig.name
                ? { height: undefined }
                : { height: "0px" }
            }
          >
            <div className="card-body">
              {
                paneConfig.filters.map(filterConfig => {
                  return <FilterControl
                    aggregations={aggregations}
                    filterConfig={filterConfig}
                    filters={filters}
                    applyFilters={applyFilters}
                    clearFilter={clearFilter}
                    count={count}
                    collapseFunc={collapseAllFunc}
                    mobileMode={true}
                    key={`key-filter-control-${filterConfig.name}`}
                  />
                })
              }
            </div>
          </div>
        </div>
}

const FiltersAccordion = ({ accordionId,
                            aggregations,
                            applyFilters,
                            clearFilter,
                            count,
                            collapseAllFunc,
                            filterPaneConfigs,
                            filters }) => {
    const [ openPane, setOpenPane ] = useState(null);

    return (
        <div className="accordion" id={accordionId}>
        {
          filterPaneConfigs.map((paneConfig, idx) => {
            if ( paneConfig.type === "checkbox-control" )  {
              return <CheckboxGroup idx={idx}
                                    key={idx}
                                    applyFilters={applyFilters}
                                    clearFilter={clearFilter}
                                    filters={filters}
                                    />
            }
            else {

            return (
              <AccordionPane accordionId={accordionId}
                         aggregations={aggregations}
                         applyFilters={applyFilters}
                         count={count}
                         key={idx}
                         clearFilter={clearFilter}
                         collapseAllFunc={collapseAllFunc}
                         filters={filters}
                         openPane={openPane}
                         paneConfig={paneConfig}
                         setOpenPane={setOpenPane} />
            )}
          })
        }
        </div>
    )
}

export { FiltersAccordion };